import { getSeoConfig } from '@/api/seo'
import { DEFAULT_SEO, ROUTE_SEO_MAP, SITE_NAME } from './defaults'

const cache = new Map()
let updateId = 0

function normalizeSeo(payload, route) {
  const data = payload && (payload.data || payload.result || payload)
  const matched = pickRouteSeo(data, route) || data || {}

  return {
    title: matched.title || matched.seoTitle || matched.seo_title,
    keywords: matched.keywords || matched.keyword || matched.seoKeywords || matched.seo_keywords,
    description:
      matched.description || matched.desc || matched.seoDescription || matched.seo_description
  }
}

function pickRouteSeo(data, route) {
  if (!data) return null

  if (Array.isArray(data)) {
    return data.find(item => {
      return item.path === route.path || item.path === route.fullPath || item.name === route.name
    })
  }

  return data[route.fullPath] || data[route.path] || data[route.name]
}

function mergeSeo(route, remoteSeo) {
  const routeSeo = ROUTE_SEO_MAP[route.name] || {}
  const seo = {
    ...DEFAULT_SEO,
    ...routeSeo,
    ...remoteSeo
  }

  seo.title = formatTitle(seo.title)
  return seo
}

function formatTitle(title) {
  if (!title) return SITE_NAME
  if (title === SITE_NAME || title.indexOf(SITE_NAME) !== -1) return title
  return title || SITE_NAME // `${title}-${SITE_NAME}`
}

function setSeo(seo, route) {
  document.title = seo.title || SITE_NAME
  setMeta('keywords', seo.keywords)
  setMeta('description', seo.description)
  setMeta('og:title', seo.title, 'property')
  setMeta('og:description', seo.description, 'property')
  setCanonical(route)
}

function setMeta(key, content, attr = 'name') {
  if (content === undefined || content === null) return

  let element = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attr, key)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

function setCanonical(route) {
  if (!window.location.origin) return

  let element = document.head.querySelector('link[rel="canonical"]')
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', 'canonical')
    document.head.appendChild(element)
  }
  element.setAttribute('href', `${window.location.origin}${route.path}`)
}

function getCacheKey(route) {
  return route.query && Object.keys(route.query).length ? route.fullPath : route.path
}

// const getSeoConfig = () => {
//   return new Promise((resolve) => {
//     const time= new Date().getTime()
//     setTimeout(() => {
//       resolve({
//         data: {
//           title: '这是一个测试标题' + time,
//           keywords: '测试,SEO,关键词' + time,
//           description: '这是一个测试描述，用于SEO优化。' + time
//         }
//       })
//     }, 1000)
//   })
// }

async function updateSeo(route) {
  const currentId = ++updateId
  const cacheKey = getCacheKey(route)

  setSeo(mergeSeo(route), route)

  if (cache.has(cacheKey)) {
    setSeo(mergeSeo(route, cache.get(cacheKey)), route)
    return
  }

  try {
    const params = { type: 1 }

    if (route.name === 'immigrationDetail') {
      // 项目详情
      params.type = 2
      params.id = route.params.id || route.query.id
    } else if (route.name === 'CaseDetail') {
      // 案例详情
      params.type = 3
      params.id = route.params.id || route.query.id
    } else if (route.name === 'newsDetail') {
      // 新闻详情
      params.type = 4
      params.id = route.params.id || route.query.id
    } else if (route.name === 'immigration') {
      // 移民列表
      params.type = 6
      params.id = 3
    } else if (route.name === 'contact') {
      // 新闻列表
      params.type = 6
      params.id = 2
    } else if (route.name === 'Case') {
      // 关于我们
      params.type = 6
      params.id = 5
    }

    console.log(params, 'seo - params')

    const response = await getSeoConfig(params)

    console.log(response, 'SEO 返回状态')

    if (currentId !== updateId) return

    const remoteSeo = normalizeSeo(response, route)
    cache.set(cacheKey, remoteSeo)
    setSeo(mergeSeo(route, remoteSeo), route)
  } catch (error) {
    cache.set(cacheKey, {})
  }
}

export default {
  install(Vue, options = {}) {
    const router = options.router
    if (!router) return

    router.afterEach(to => {
      console.log('SEO 路由监听', to)

      updateSeo(to)
    })
  }
}
